import { render, staticRenderFns } from "./TestimonialsSection.vue?vue&type=template&id=759fe7b4&scoped=true"
import script from "./TestimonialsSection.vue?vue&type=script&lang=js"
export * from "./TestimonialsSection.vue?vue&type=script&lang=js"
import style0 from "./TestimonialsSection.vue?vue&type=style&index=0&id=759fe7b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759fe7b4",
  null
  
)

export default component.exports